<template>
  <div class="status-card status-reviewing">
    <div class="status-header">
      <div class="status-icon-wrapper reviewing">
        <img
          alt="reviewing"
          width="48px"
          :src="waitingVerifyImg"
        >
      </div>
      <h3 class="status-title">
        Admin đang xét duyệt
      </h3>
    </div>

    <div class="status-content">
      <p class="status-description">
        Cảm ơn bạn đã gởi thông tin! Đội ngũ của chúng tôi sẽ xem xét thông tin này và phản hồi đến email xác minh của bạn trong vòng 2 - 3 ngày làm việc.
      </p>

      <div class="action-section">
        <div class="action-item">
          <div class="action-icon">
            <img
              alt="email"
              width="24px"
              :src="iconEmailSquare"
            >
          </div>
          <div class="action-content">
            <p class="action-title">
              Kiểm tra email
            </p>
            <p class="action-description">
              Vui lòng kiểm tra email (bao gồm cả thư spam/thư rác) để nhận kết quả xét duyệt. Trong trường hợp bị từ chối, bạn sẽ nhận được hướng dẫn xử lí qua email.
            </p>
          </div>
        </div>
      </div>

      <user-hint class="justify-content-center mt-4" />
    </div>
  </div>
</template>

<script>
import UserHint from '@/components/UserHint.vue'
import envMixin from '@/mixins/envMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import iconWaitingVerifyEmedia from '@/assets/images/pages/adsAccount/icon-waiting-verify-emedia.svg'
import iconHeartSuccess from '@/assets/images/pages/adsAccount/icon-heart-success.png'
import iconEmailSquare from '@/assets/images/icons/ic-email-square.svg'

export default {
  name: 'ReviewingStatus',

  components: {
    UserHint,
  },

  mixins: [stepGuideMixin, envMixin],

  data() {
    return {
      iconEmailSquare,
    }
  },

  computed: {
    waitingVerifyImg() {
      if (this.isEmediaPlatform) {
        return iconWaitingVerifyEmedia
      }
      return iconHeartSuccess
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.status-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;

  @media(max-width: 767px) {
    padding: 24px;
    border-radius: 12px;
  }
}

.status-header {
  text-align: center;
  margin-bottom: 28px;
}

.status-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    display: block;
    margin: 0 auto;
  }

  &.reviewing {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 51, 234, 0.1) 100%);
  }
}

.status-title {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  line-height: 1.4;

  @media(max-width: 767px) {
    font-size: 20px;
  }
}

.status-content {
  text-align: left;
}

.status-description {
  font-size: 16px;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 24px;
  text-align: center;

  @media(max-width: 767px) {
    font-size: 14px;
    margin-bottom: 20px;
  }
}

.action-section {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.action-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;

  & + & {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
  }
}

.action-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.action-content {
  flex: 1;
}

.action-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 4px 0;
  line-height: 1.4;

  @media(max-width: 767px) {
    font-size: 14px;
  }
}

.action-description {
  font-size: 14px;
  line-height: 1.5;
  color: #6b7280;
  margin: 0;

  @media(max-width: 767px) {
    font-size: 13px;
  }
}
</style>
